import Cookies from "js-cookie";
import { getCsrfToken } from "@/app/_utils/csrf";

class EmailService {
  static instance: EmailService;

  csrfToken = getCsrfToken();
  tenant = Cookies.get("tenant") ?? "";
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

  getEmailAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}emails/${id}/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getEmailsAsync = async () => {
    const res = await fetch(`${this.baseUrl}emails/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  createEmailAsync = async (Email: any) => {
    const res = await fetch(`${this.baseUrl}emails/`, {
      method: "POST",
      body: JSON.stringify(Email),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  updateEmailAsync = async (id: string, Email: any) => {
    const res = await fetch(`${this.baseUrl}emails/${id}/`, {
      method: "PUT",
      body: JSON.stringify(Email),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  deleteEmailAsync = async (id: string) => {
    return await fetch(`${this.baseUrl}emails/${id}/`, {
      method: "DELETE",
      headers: { "X-CSRFToken": this.csrfToken },
      credentials: "include",
    });
  };

  sendEmailAsync = async (id: string, payload: { scheduled_at?: string; filters?: any }) => {
    const res = await fetch(`${this.baseUrl}emails/${id}/send/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });
    return await res.json();
  };

  getEmailStatsAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}emails/${id}/stats/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getRecipientCountAsync = async (id: string, filters: any) => {
    const params = new URLSearchParams({ filters: JSON.stringify(filters) });
    const res = await fetch(`${this.baseUrl}emails/${id}/recipient-count/?${params}`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getRecipientPreviewAsync = async (id: string, filters: any) => {
    const params = new URLSearchParams({ filters: JSON.stringify(filters) });
    const res = await fetch(`${this.baseUrl}emails/${id}/recipient-preview/?${params}`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getReceiptsAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}emails/${id}/receipts/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };
}

export default new EmailService();
